import { DynamicComponent } from "modules/storyblok/DynamicComponent";
import { GridItem } from "@chakra-ui/react";
import type { SbEditableComponentProps } from "types/storyblok";
import type { ColumnProps } from "./Column.d";

const justifyContent = { top: "flex-start", middle: "center", bottom: "flex-end" };
const alignItems = { left: "flex-start", center: "center", right: "flex-end", stretch: "stretch" };

const Column = ({
  colSpanMobile,
  colSpanTablet,
  colSpanDesktop,
  vAlignmentMobile,
  vAlignmentTablet,
  vAlignmentDesktop,
  mtMobile,
  mtTablet,
  mtDesktop,
  mbMobile,
  mbTablet,
  mbDesktop,
  hAlignmentMobile,
  hAlignmentTablet,
  hAlignmentDesktop,
  textAlignMobile,
  textAlignTablet,
  textAlignDesktop,
  orderMobile,
  orderTablet,
  orderDesktop,
  content,
  sbEditable,
}: SbEditableComponentProps<ColumnProps>) => (
  <GridItem
    colSpan={{ base: +colSpanMobile, md: +colSpanTablet, lg: +colSpanDesktop }}
    display={{
      base: +colSpanMobile > 0 ? "flex" : "none",
      md: +colSpanTablet > 0 ? "flex" : "none",
      lg: +colSpanDesktop > 0 ? "flex" : "none",
    }}
    flexDir="column"
    justifyContent={{
      base: justifyContent[vAlignmentMobile],
      md: justifyContent[vAlignmentTablet],
      lg: justifyContent[vAlignmentDesktop],
    }}
    alignItems={{
      base: alignItems[hAlignmentMobile],
      md: alignItems[hAlignmentTablet],
      lg: alignItems[hAlignmentDesktop],
    }}
    mt={{ base: mtMobile, md: mtTablet, lg: mtDesktop }}
    mb={{ base: mbMobile, md: mbTablet, lg: mbDesktop }}
    // @ts-ignore
    textAlign={{ base: textAlignMobile, md: textAlignTablet, lg: textAlignDesktop }}
    // @ts-ignore
    order={{ base: +orderMobile, md: +orderTablet, lg: +orderDesktop }}
    {...sbEditable}
  >
    {content.map((item) => (
      <DynamicComponent blok={item} key={item._uid} />
    ))}
  </GridItem>
);

export default Column;
